import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Card,
  CardContent,
  Chip,
} from '@mui/material';
import {
  People,
  Assignment,
  Warning,
  CheckCircle,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const AdminDashboardPage: React.FC = () => {
  const { t } = useTranslation();

  const stats = [
    {
      title: t('admin.pendingCustomers'),
      value: '12',
      icon: <People />,
      color: 'warning',
      bgColor: 'warning.light',
    },
    {
      title: 'Total Orders',
      value: '156',
      icon: <Assignment />,
      color: 'primary',
      bgColor: 'primary.light',
    },
    {
      title: 'Sync Issues',
      value: '3',
      icon: <Warning />,
      color: 'error',
      bgColor: 'error.light',
    },
    {
      title: 'Active Users',
      value: '89',
      icon: <CheckCircle />,
      color: 'success',
      bgColor: 'success.light',
    },
  ];

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        {t('admin.dashboard')}
      </Typography>

      <Grid container spacing={3}>
        {/* Statistics Cards */}
        {stats.map((stat, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, md: 3 }}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Box
                    sx={{
                      p: 1,
                      borderRadius: 1,
                      bgcolor: stat.bgColor,
                      color: 'white',
                      mr: 2,
                    }}
                  >
                    {stat.icon}
                  </Box>
                  <Typography variant="h4" color={`${stat.color}.main`}>
                    {stat.value}
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {stat.title}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}

        {/* Customer Verification Queue */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              {t('admin.customerVerification')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {[1, 2, 3].map((item) => (
                <Box
                  key={item}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    p: 2,
                    border: 1,
                    borderColor: 'grey.200',
                    borderRadius: 1,
                  }}
                >
                  <Box>
                    <Typography variant="subtitle2">
                      PT Mitra Konstruksi {item}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      customer{item}@example.com
                    </Typography>
                  </Box>
                  <Chip label="Pending" color="warning" size="small" />
                </Box>
              ))}
            </Box>
          </Paper>
        </Grid>

        {/* System Status */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              {t('admin.syncStatus')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2">Epicor Customer Sync</Typography>
                <Chip label="Active" color="success" size="small" />
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2">Product Catalog Sync</Typography>
                <Chip label="Active" color="success" size="small" />
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2">Order Sync</Typography>
                <Chip label="Error" color="error" size="small" />
              </Box>
              <Typography variant="caption" color="text.secondary">
                {t('admin.lastSync')}: 10 minutes ago
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminDashboardPage;